import controller from './yearly-contracted-dialog.controller';

export default {
  controller,
  template: require('./yearly-contracted-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/yearly-contracted-info/yearly-contracted-dialog.component.ts